import Translate from '../../common/functions/translate';
import { Lang, OfferStatus, CategoryType } from "../enums";
import pdfIcon from "../../assets/images/filetypes/pdf-icon.png";
import xlsIcon from "../../assets/images/filetypes/xls-icon.png";
import wordIcon from "../../assets/images/filetypes/word-doc-icon.png";
import txtIcon from "../../assets/images/filetypes/txt-icon.png";
import zipIcon from "../../assets/images/filetypes/zip-icon.png";
import jpgIcon from "../../assets/images/filetypes/jpg-icon.png";
import pngIcon from "../../assets/images/filetypes/png-icon.png";
import * as Items from '../../catalog/items/index';
import * as Fittings from '../../catalog/fittings/index';
import { ElementsFactories } from 'react-planner';

export function clone(item) {
  return (
    // return cloned copy so that the item is passed by value instead of by reference
    JSON.parse(JSON.stringify(item))
  );
}

// export function getErrorMessage(error) {
//   if (error.response) {
//     return { message: `${error.response.status} ${error.response.statusText}` }
//   } else {
//     return { message: `${error.message}` }
//   }
// }

export function getErrorMessage(error) {
  if (error.response) {
    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.ErrorCode
    ) {
      return { message: Translate(`${error.response.data.Data.ErrorCode}`) };
    }

    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.Message
    ) {
      return { message: `${error.response.data.Data.Message}` };
    }

    if (error.response.data) {
      return { message: Translate(`${error.response.data}`) };
    }

    return { message: `${error.response.status} ${error.response.statusText}` };
  } else {
    return { message: Translate(`${error.message}`) };
  }
}

export function getQueryParam(locationSearch: string, paramName: string) {
  const query = new URLSearchParams(locationSearch);
  return query.get(paramName);
}

export function fomatDateAsString(date: Date) {
  return date.getFullYear().toString() + '-' +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '-' +
    (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString());
}

export function fomatDateTimeAsString(date: Date) {
  return date.getFullYear().toString() + '-' +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '-' +
    (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString()) + " " +
    ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
}

export function formatDateTimeAsString(date: Date) {
  return (date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString()) + "." +
    (date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()) + '.' +
    date.getFullYear().toString() + ' ' +
    ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
}

export function formatBytes(bytes, decimals) {
  if (bytes === 0) return '0 Bytes';
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

//Groups array by objects property and returns object of arrays
export function groupByReturnObject(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

//Groups array by objects property and returns array of arrays
export function groupByReturnArray(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, []);
}

// export function enumToDropdownArray(enumName) {
//   let enumAsArray: Array<{ value: number, label: string }> = [];
//   for (var n in enumName) {
//     if (typeof enumName[n] === 'number') {
//       enumAsArray.push({ value: +enumName[n], label: n });
//     }
//   }
//   return enumAsArray;
// }

export function enumToDropdownArray(enumName, withTranslation?: boolean) {
  let enumAsArray: Array<{ value: number, label: string }> = [];
  for (var n in enumName) {
    if (typeof enumName[n] === 'number') {
      enumAsArray.push({ value: +enumName[n], label: withTranslation ? Translate(n) : n });
    }
  }
  return enumAsArray;
}

export function getEnumLabel(id: number, enumName: any, withTranslation?: boolean) {
  let enumElement = Object
    .keys(enumName)
    .find(key => enumName[key] === id);

  if (withTranslation) {
    return Translate(enumElement);
  }
  else {
    return enumElement;
  }
}

export function getEnumKeys(enumName: any) {
  return Object.keys(enumName).filter(k => typeof enumName[k as any] === "number");
}

export function getLangId(lang: string) {
  switch (lang) {
    case 'bg':
      return Lang.bg;
    case 'en':
      return Lang.en;
  }
}


export function getURLParameter(name) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
}

export function formatAlarmTime(alarmTime: any) {
  if (typeof alarmTime === 'string') {
    if (alarmTime.length > 8) {
      return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
    } else {
      return fomatTimeStringWithoutSecondsAsString(alarmTime);
    }
  } else {
    return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
  }
}

export function fomatTimeWithoutSecondsAsString(date: Date) {
  return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
}

export function fomatTimeStringWithoutSecondsAsString(time: string) {
  return time.slice(0, 5);
}

export function formatDateAsLongString(date: Date) {
  var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
  var month = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
  var year = date.getFullYear();
  var hour = ('0' + date.getHours()).substr(-2);
  var minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  var seconds = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();

  var str = `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;

  return str;
}

export function fomatDatesStringWithLang(date: Date) {
  let lang = localStorage.getItem('lang');
  if (!lang) {
    lang = 'bg';
    //localStorage.setItem('lang', 'bg');
  }
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г."
      );
    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString()
      );
  }
}

export function getIconByFileType(fileType: string) {
  switch (fileType.toLowerCase()) {
    case "pdf":
      return pdfIcon;
    case "xls":
    case "xlsx":
      return xlsIcon;
    case "doc":
    case "docx":
      return wordIcon;
    case "txt":
      return txtIcon;
    case "zip":
      return zipIcon;
    case "jpg":
      return jpgIcon;
    case "png":
      return pngIcon;
  }
}

export function calculateProductsPrice(array) {
  return array.reduce((acc, curVal) => acc + (curVal.quantity * curVal.price), 0);
}

export function lineBreakWord(word: string, maxLength: number, numberOfLines?: number) {
  let retunedArr = new Array<string>(0);
  let splitWord = word.split(' ');
  retunedArr = splitWord.reduce((prev, curr) => {
    if (prev.length === 0) {
      prev.push(curr);
    }
    else {
      if (prev[prev.length - 1].length + curr.length <= maxLength) {
        prev[prev.length - 1] += ' ' + curr;
      }
      else {
        if (!numberOfLines || (numberOfLines && numberOfLines > prev.length))
          prev.push(curr);
      }
    }

    return prev;
  }, new Array<string>(0))
  return retunedArr;
}

export function getOfferStatusColor(offerStatus: OfferStatus) {
  switch (offerStatus) {
    case OfferStatus.NewOffer:
      return { backgroundColor: "#ffec44", padding: "5px", color: "#000" }; // ffec44
    case OfferStatus.Expired:
      return { backgroundColor: "#ff9616", padding: "5px", color: "#fff" };
    case OfferStatus.Accepted:
      return { backgroundColor: "#349646", padding: "5px", color: "#fff" };
    case OfferStatus.InExecution:
      return { backgroundColor: "#04b4d3", padding: "5px", color: "#fff" };
    case OfferStatus.Finished:
      return { backgroundColor: "#0059a3", padding: "5px", color: "#fff" };
    case OfferStatus.SentToClient:
      return { backgroundColor: "#beffae", padding: "5px", color: "#000" };
    default:
      return { backgroundColor: "#ddd", padding: "5px", color: "#fff" };
  }

}

export function checkIsThatType(categoryId, categories, type) {
  let isSearchedType = false;
  let category = categories.find(r => r.remoteId === categoryId);
  if (category) {
    if (category.categoryTypeId === type) {
      isSearchedType = true;
    }
    else {
      if (category.parentId)
        isSearchedType = checkIsThatType(category.parentId, categories, type);
    }
  }
  return isSearchedType;
}

export function getAllTypesToRoot(categoryId, categories) {
  let statuses: Array<number> = new Array<number>(0);
  let category = categories.find(r => r.remoteId === categoryId);
  if (category && category.categoryTypeId)
    statuses.push(category.categoryTypeId)
  if (category && category.parentId)
    statuses.push(...getAllTypesToRoot(category.parentId, categories));

  return statuses
}

export function getAllCategoriesToRoot(categoryId, categories) {
  let categoryName: Array<string> = new Array<string>(0);
  let category = categories.find(r => r.remoteId === categoryId);
  if (category && category.name)
    categoryName.push(category.name)
  if (category && category.parentId)
    categoryName.push(...getAllCategoriesToRoot(category.parentId, categories));

  return categoryName;
}

export function createNewCategoryElement(element, productImages, categories) {
  let productImage = productImages.find(r => r.remoteId === element.fileId);
  if (element.fileId && productImage) {
    return getItemFromCatalog([productImage.name], element, []);
  }
  else {
    if (element.category) {
      return getItemFromCatalog([], element, getAllTypesToRoot(element.categoryId, categories));
    }
  }
  let name = element.remoteId ? element.remoteId + "" : element.productId + "";
  return createItemForCatalog(name, element.articleNumber, Items.Default.info.image, element.article,
    Items.Default.properties, Items.Default.render2D, Items.Default.render3D, Items.Default.renderAxonomertic);
}

export function getItemFromCatalog(names, element, categoryType) {
  var image: any;
  var render2D = {};
  var render3D = {};
  var renderAxonomertic = {}
  var properties = {};

  image = Items.Default.info.image;
  render2D = Items.Default.render2D;
  render3D = Items.Default.render3D;
  renderAxonomertic = Items.Default.renderAxonomertic;
  properties = Items.Default.properties;
  // if there a the first is picture name, and there are 2 checks for name bg and en
  if (names.some(r => r.toLowerCase() === 'cauldron') || categoryType.some(r => r === CategoryType.Cauldrons)) {
    image = Items.Cauldron.info.image;
    render2D = Items.Cauldron.render2D;
    render3D = Items.Cauldron.render3D;
    properties = Items.Cauldron.properties;
    renderAxonomertic = Items.Cauldron.renderAxonomertic;
  }

  if (names.some(r => r.toLowerCase() === 'kitchen') || categoryType.some(r => r === CategoryType.Stoves)) {
    image = Items.Kitchen.info.image;
    render2D = Items.Kitchen.render2D;
    render3D = Items.Kitchen.render3D;
    properties = Items.Kitchen.properties;
    renderAxonomertic = Items.Kitchen.renderAxonomertic;
  }

  if (names.some(r => r.toLowerCase() === 'radiator') || categoryType.some(r => r === CategoryType.Radiators)) {
    image = Items.RadiatorModernStyle.info.image;
    render2D = Items.RadiatorModernStyle.render2D;
    render3D = Items.RadiatorModernStyle.render3D;
    renderAxonomertic = Items.RadiatorModernStyle.renderAxonomertic;
    properties = Items.RadiatorModernStyle.properties;
  }

  if (names.some(r => r.toLowerCase() === 'smoke-extractor') || categoryType.some(r => r === CategoryType.Flues)) {
    image = Items.SmokeExtractor.info.image;
    render2D = Items.SmokeExtractor.render2D;
    render3D = Items.SmokeExtractor.render3D;
    renderAxonomertic = Items.SmokeExtractor.renderAxonomertic;
    properties = Items.SmokeExtractor.properties;
  }

  if (names.some(r => r.toLowerCase() === 'boiler') || categoryType.some(r => r === CategoryType.Boilers)) {
    image = Items.Boiler.info.image;
    render2D = Items.Boiler.render2D;
    render3D = Items.Boiler.render3D;
    renderAxonomertic = Items.Boiler.renderAxonomertic;
    properties = Items.Boiler.properties;
  }

  if (categoryType.some(r => r === CategoryType.TowelRails) || names.some(r => r.toLowerCase() === 'lyre')) {
    image = Items.Lyre.info.image;
    render2D = Items.Lyre.render2D;
    render3D = Items.Lyre.render3D;
    renderAxonomertic = Items.Lyre.renderAxonomertic;
    properties = Items.Lyre.properties;
  }

  if (names.some(r => r.toLowerCase() === 'hot-plate')) {
    image = Items.HotPlate.info.image;
    render2D = Items.HotPlate.render2D;
    render3D = Items.HotPlate.render3D;
    renderAxonomertic = Items.HotPlate.renderAxonomertic;
    properties = Items.HotPlate.properties;
  }

  if (categoryType.some(r => r === CategoryType.Convectors) || names.some(r => r.toLowerCase() === 'convector')) {
    image = Items.Convector.info.image;
    render2D = Items.Convector.render2D;
    render3D = Items.Convector.render3D;
    renderAxonomertic = Items.Convector.renderAxonomertic;
    properties = Items.Convector.properties;
  }

  if (names.some(r => r.toLowerCase() === 'magnet-ventil')) {
    image = Fittings.MagnetVentil.info.image;
    render2D = Fittings.MagnetVentil.render2D;
    render3D = Fittings.MagnetVentil.render3D;
    renderAxonomertic = Fittings.MagnetVentil.renderAxonomertic;
    properties = Fittings.MagnetVentil.properties;
  }

  if (names.some(r => r.toLowerCase() === 'coupling')) {
    image = Fittings.Coupling.info.image;
    render2D = Fittings.Coupling.render2D;
    render3D = Fittings.Coupling.render3D;
    renderAxonomertic = Fittings.Coupling.renderAxonomertic;
    properties = Fittings.Coupling.properties;
  }

  if (names.some(r => r.toLowerCase() === 'triple')) {
    image = Fittings.Triple.info.image;
    render2D = Fittings.Triple.render2D;
    render3D = Fittings.Triple.render3D;
    renderAxonomertic = Fittings.Triple.renderAxonomertic;
    properties = Fittings.Triple.properties;
  }

  if (names.some(r => r.toLowerCase() === 'ventil')) {
    image = Fittings.Ventil.info.image;
    render2D = Fittings.Ventil.render2D;
    render3D = Fittings.Ventil.render3D;
    renderAxonomertic = Fittings.Ventil.renderAxonomertic;
    properties = Fittings.Ventil.properties;
  }

  if (names.some(r => r.toLowerCase() === 'elbow')) {
    image = Fittings.Elbow.info.image;
    render2D = Fittings.Elbow.render2D;
    render3D = Fittings.Elbow.render3D;
    renderAxonomertic = Fittings.Elbow.renderAxonomertic;
    properties = Fittings.Elbow.properties;
  }

  if (names.some(r => r.toLowerCase() === 'steel-radiator')) {
    image = Items.SteelRadiator.info.image;
    render2D = Items.SteelRadiator.render2D;
    render3D = Items.SteelRadiator.render3D;
    renderAxonomertic = Items.SteelRadiator.renderAxonomertic;
    properties = Items.SteelRadiator.properties;
  }

  if (categoryType.some(r => r === CategoryType.Pipes) && categoryType.some(r => r === CategoryType.GasInstallation)) {
    let name = element.remoteId ? element.remoteId + "" : element.productId + "";
    const info = {
      title: element.articleNumber,
      tag: ['pipe'],
      description: element.article,
      image: require('../../catalog/pipes/gas/pipe.png'),
      visibility: {
        catalog: true,
        layerElementsVisible: true
      }
    };
    return ElementsFactories.PipeFactoryGas(name, info, null, element.diameter);
  }

  if (categoryType.some(r => r === CategoryType.Pipes) && categoryType.some(r => r === CategoryType.HeatInstallation)) {
    let name = element.remoteId ? element.remoteId + "" : element.productId + "";
    const info = {
      title: element.articleNumber,
      tag: ['pipe'],
      description: element.article,
      image: require('../../catalog/pipes/water/pipe-water.png'),
      visibility: {
        catalog: true,
        layerElementsVisible: true
      }
    };
    return ElementsFactories.PipeFactoryWater(name, info, null, element.diameter);
  }


  let name = element.remoteId ? element.remoteId + "" : element.productId + "";
  return createItemForCatalog(name, element.articleNumber, image, element.article, properties, render2D, render3D, renderAxonomertic);
}

export function newVoidElement(name, itemName, desc) {
  let newelement = {
    name: name,
    prototype: "items",
    info: {
      tag: ['metal'],
      title: itemName,
      image: Items.Void.info.image,
      description: desc
    },
    properties: Items.VoidNoProperties.properties,
    render2D: Items.VoidNoProperties.render2D,
    render3D: Items.VoidNoProperties.render3D
  };
  return newelement;
}

export function createItemForCatalog(name, title, image, description, properties, render2D, render3D, renderAxonomertic) {
  let newelement = {
    name: name,
    prototype: "items",
    info: {
      tag: ['metal'],
      title: title,
      image: image,
      description: description,
      isFromDb: true
    },
    properties: properties,
    render2D: render2D,
    render3D: render3D,
    renderAxonomertic: renderAxonomertic
  };
  return newelement;
}

export function plannerVersionUpdates(planner) {
  for (let layer in planner.layers) {
    for (let pipe in planner.layers[layer].pipes) {
      if (planner.layers[layer].pipes[pipe].type === 'pipe') {
        if (layer === 'layer-3') {
          planner.layers[layer].pipes[pipe].type = 'water-pipe';
        }
        else {
          planner.layers[layer].pipes[pipe].type = 'gas-pipe';
        }
      }

      let properties = planner.layers[layer].pipes[pipe].properties;

      if (!properties.diameter) {
        properties = { ...properties, diameter: { length: 0, unit: "cm" } }
      }

      if (!properties.altitude) {
        properties = { ...properties, altitude: { length: 0, unit: "cm" } }
      }

      if (!properties.thickness) {
        properties = { ...properties, thickness: { length: 0 } }
      }

      if (!properties.is_dashedLine) {
        properties = { ...properties, is_dashedLine: false }
      }
    }
  }
  return planner;
}

